function forceDefaultHeaderDrawer() {
  const header = document.querySelector('#header-component[data-force-drawer]');
  if (!header || header.dataset.forceDrawerInitialized === 'true') return;

  const forceDrawer = () => {
    if (header.dataset.menuStyle !== 'drawer') header.dataset.menuStyle = 'drawer';
  };

  header.dataset.forceDrawerInitialized = 'true';
  forceDrawer();

  new MutationObserver(forceDrawer).observe(header, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', forceDefaultHeaderDrawer, { once: true });
} else {
  forceDefaultHeaderDrawer();
}
